<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="historybuy_detailLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="historybuy_detailError" class="mc-error">{{ historybuy_detailError }}</div>
      <div v-if="historybuy_detailLoaded" class="mc-order">
        <div class="mc-order__card mc-order-card">
          <div class="mc-order-card__top">
                            <span class="mc-order-card__status">
                                {{ historybuy_detail.header.status }}
                            </span>
            <div class="mc-order-card__title">
              {{ historybuy_detail.header.name }} от {{ historybuy_detail.header.date_create }}
            </div>
          </div>
          <dl class="mc-order-card__list">
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Магазин:
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.header.store }}
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Стоимость товара:
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.header.total }} ₽
              </dd>
            </div>
            <div v-if="historybuy_detail?.bitrix_data?.DELIVERY" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Стоимость доставки:
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.DELIVERY.PRICE }} ₽
              </dd>
            </div>
            <div v-if="historybuy_detail.discount" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Оплата бонусами:
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.discount }} ₽
              </dd>
            </div>
            <div class="mc-order-card__item mc-order-card__item--total">
              <dt class="mc-order-card__term">
                Сумма заказа:
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.header.total }} ₽
              </dd>
            </div>
          </dl>
          <template v-for="payment in historybuy_detail.payments">
          <div v-if="payment.url" class="mc-order-card__bottom">
            <a class="mc-button mc-button--color" :href="payment.url" target="_blank">
                                <span class="mc-button__text">
                                    Оплатить
                                </span>
            </a>
          </div>
          </template>
        </div>
        <ul class="mc-order__list">
          <li v-for="product in historybuy_detail.items" class="mc-order__item">
            <router-link :to="product.ELEMENT_ID?'/detail/'+product.ELEMENT_ID+'/':'#'" class="mc-product-item">
              <div class="mc-product-item__image-wrapper">
                <picture class="mc-product-item__picture">
                  <img v-if="product.PICTURE_RESIZED"  class="mc-product-item__image" :src="product.PICTURE_RESIZED" width="94" height="157" alt="">
                </picture>
              </div>
              <div class="mc-product-item__body">
                                    <span class="mc-product-item__title">
                                        {{ product.product_name }}
                                    </span>
                <span class="mc-product-item__code" v-if="product.article">
                                        {{ product.article }}
                                    </span>
                <span class="mc-product-item__code" v-if="product.characteristic">
                                        {{ product.characteristic }}
                                    </span>
                <div class="mc-product-item__price mc-price">
                                        <span v-if="product.discount > 0" class="mc-price__old">
                                            {{ product.oldprice }} ₽
                                        </span>
                  <span class="mc-price__current">
                                            {{ product.price }} ₽
                                        </span>

                </div>
                <span class="mc-product-item__code" v-if="product.tooltip" v-html="product.tooltip">

                                    </span>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="mc-order__card mc-order-card">
          <dl class="mc-order-card__list mc-order-card__list--grid">
            <div v-if="historybuy_detail.bitrix_data?.PAYMENT" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Способ оплаты
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.PAYMENT.PAY_SYSTEM_NAME }}
              </dd>
            </div>
            <div v-if="historybuy_detail.bitrix_data?.DELIVERY" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Доставка
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.DELIVERY.NAME }}
              </dd>
            </div>
            <div v-if="historybuy_detail?.bitrix_data?.PROPERTIES?.ADDRESS" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Адрес
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.PROPERTIES.ADDRESS.VALUE }}
              </dd>
            </div>
            <div v-if="historybuy_detail?.bitrix_data?.PROPERTIES?.PHONE" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Телефон
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.PROPERTIES.PHONE.VALUE }}
              </dd>
            </div>
            <div v-if="historybuy_detail?.bitrix_data?.PROPERTIES?.FIO" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Получатель
              </dt>
              <dd class="mc-order-card__description">
                {{ historybuy_detail.bitrix_data.PROPERTIES.FIO.VALUE }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'historybuy_detail',
      'historybuy_detailLoading',
      'historybuy_detailError',
      'historybuy_detailLoaded'
    ])
  },
  mounted() {

  },
  created() {
    this.fetchHistoryBuy_detail(this.$route.params.id);
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchHistoryBuy_detail',
    ]),
  },
}
</script>


